import { useEffect, useState } from "react"
import { StepWizard, Wizard } from "../../bpm/config/Componentes/wizard/Wizard"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BudgetRPForm } from "./BudgetRPForm"
import { RegisterRFContract } from "./RegisterRFContract"
import { CreateRFDocument } from "./CreateRFDocument"
import { _AdquisitionContractRP, _ItemFlow, _single } from "../../../core/services/dataBean/EntityCatalog"
import { Alert } from "../../theme/Component/Alert"
import { BasicButton } from "../../theme/Component/BasicButton"
import { toast } from "react-toastify"
import { PrintJson } from "../../theme/Component/PrintJson"


interface MapProperties {
    FormData: Record<string, any>;
    ObjectList: object[];
    DocumentList: Record<string, any>;
}

interface ProcedureFunctions {
    _procedure: any;
    _pocessData?: any;
    _exportMap: Function;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure?: ProcedureFunctions;
    modal?: boolean;
}

export const BudgetRPFactory = ({ modal = true, configProcedure }: Props) => {
    const [props, setProps] = useState<any>({});
    const [obs, setObs] = useState<string>("");

    const [canDiscard, setCanDiscard] = useState<boolean>(false);
    const [map, setMap] = useState<MapProperties>({
        FormData: {},
        ObjectList: [],
        DocumentList: {}
    });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            const x = configProcedure?._procedure ? configProcedure._procedure.IDProcedureImp : null;
            setProps({ ...configProcedure?._pocessData?.Props, "IDPIMP": x })
        }
    }, [configProcedure?._pocessData])

    const onExportMap = (rp) => {
        let doc = {
            IDAdquisitionItem: props.IDAdquisitionItem,
            IDDocument: props.IDDocument ?? rp.IDDocument,
            DocumentDate: props.DocumentDate ?? rp.DocumentDate,
            Mnemonic: props.Mnemonic ?? rp.Mnemonic,
            Consecutive: props.Consecutive ?? rp.Consecutive,
        }

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(props.IDDocument ? obs : `Se genera el Documento ${doc.Mnemonic} - ${doc.Consecutive} en el proceso`)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(doc)
        }
    }
    const steps: StepWizard[] = [
        {
            keyID: "0",
            name: 'PASO 1. Formulario',
            onEvent: () => { },
            children: <BudgetRPForm formdata={props} onChange={(e) => { setMap({ ...map, "FormData": e }) }} />,
            validButton: Boolean(
                map.FormData.AccountantDate &&
                map.FormData.ContractValue &&
                map.FormData.ContractNumber &&
                map.FormData.IDAccount &&
                map.FormData.ContractDescription
            ),
            canReturn: false
        },
        {
            keyID: "1",
            name: 'PASO 2. Rubros Presupuestales a Registrar',
            onEvent: () => { },
            children: <RegisterRFContract formData={map.FormData} contract={map.FormData.Contract} onChange={(e) => { setMap({ ...map, "ObjectList": e }) }} />,
            validButton: Boolean(map.ObjectList.length > 0),
            canReturn: true
        },
        {
            keyID: "2",
            name: 'PASO 3. Crear Registro Presupuestal',
            onEvent: () => { onExportMap(map.DocumentList.Response) },
            children: <CreateRFDocument
                eventCreate={(e) => {
                    if (configProcedure?._pushProps) {
                        configProcedure?._pushProps(e)
                    }
                }}
                onChange={(e) => { setMap({ ...map, "DocumentList": e }) }}
                rpList={map.ObjectList}
                contrato={map.FormData.Contract}
                formData={map.FormData} />,
            validButton: (map.DocumentList?.Response?.IDDocument ? true : false),
            canReturn: canDiscard,
            canDiscard: canDiscard,
            labelList: { labelNext: `${props.IDAdquisitionItem ? "Asociar RP" : "Finalizar Proceso"}` }
        }
    ]

    const [invalid, setInvalid] = useState<boolean>(false);

    return (
        <>
            {modal ?
                <div className="row">
                    <div className="col-md-12">
                        {configProcedure?._procedure?.IDProcedureImp ?
                            <>
                                {props.IDDocument ?
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Alert clase="info text-center" children={`Ya se creo el Documento ${props.Mnemonic} - ${props.Consecutive} para este proceso`} />
                                        </div>
                                        <div className="col-md-12">
                                            <label>Observaciones:</label>
                                            <textarea className={`form-control ${invalid ? "is-invalid" : ""}`} onBlur={() => { setInvalid(false) }} value={obs} onChange={(e) => { setObs(e.target.value) }} />
                                        </div>
                                        <div className="col-md-12 mt-4">
                                            <BasicButton eventClick={() => {
                                                if (obs && obs.length > 15) {
                                                    onExportMap(props)
                                                } else {
                                                    setInvalid(true);
                                                    toast.error("La justificación debe tener un mínimo de 15 caracteres");
                                                }
                                            }} icon="ri-save-line" children={"Continuar"} />
                                        </div>
                                    </div>
                                    :
                                    <Wizard title="Generar Registro Presupuestal" listStep={steps} />
                                }
                            </>
                            :
                            <Wizard title="Generar Registro Presupuestal" listStep={steps} />
                        }
                    </div>
                </div>
                :
                <BasicPage titulo="Generar Registro Presupuestal">
                    <Wizard title="Certificado" listStep={steps} />
                </BasicPage>
            }
        </>
    )
}